import Vue from 'vue';
import App from './App.vue';
import Router from'vue-router';
import axios from'axios';
import VueGtag from "vue-gtag";
import VueMeta from 'vue-meta';
import Reveal from './directives/reveal';
import LazyVideo from './directives/lazyVideo';
import { BootstrapVue } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Route-level code splitting: each page becomes its own chunk
const Home = () => import('./components/Home.vue');
const Employers = () => import('./components/Employers.vue');
const Features = () => import('./components/Features.vue');
const FAQ = () => import('./components/FAQ.vue');
const Articles = () => import('./components/Articles.vue');
const Article = () => import('./components/Article.vue');
const Download = () => import('./components/Download.vue');
const About = () => import('./components/About.vue');
const GetItAtWork = () => import('./components/GetItAtWork.vue');
const Policy = () => import('./components/Policy.vue');
const Terms = () => import('./components/Terms.vue');
const AppTerms = () => import('./components/AppTerms.vue');
const Linked = () => import('./components/Linked.vue');
const Welcome = () => import('./components/Welcome.vue');
const Launch = () => import('./components/Launch.vue');
const Signup = () => import('./components/Signup.vue');
const EmployeeKeysUpload = () => import('./components/EmployeeKeysUpload.vue');
const NotFound = () => import('./components/NotFound.vue');
const Mail = () => import('./components/Mail.vue');

Vue.use(BootstrapVue);
Vue.use(Router);
Vue.use(VueGtag, {config: { id: "G-MV7QYPVWEZ" }});
Vue.use(VueMeta);
Vue.directive('reveal', Reveal);
Vue.directive('lazyvideo', LazyVideo);
Vue.config.productionTip = false;

// Keep this a bare literal: publish.sh seds the hostname in this file at deploy time.
var api = "https://api.moneyguided.com";

// Every call site sets a `busy` flag and clears it in .then/.catch, so a request that
// never settles leaves the UI spinning with no way out. A timeout turns that into an
// error the existing .catch handlers already cope with.
// ponytail: timeout only. No interceptors, no retry — the signup calls are unauthenticated
// one-shots, so there's nothing to refresh and nothing safe to blind-retry (POST /Customers).
Vue.prototype.$http = axios.create({ timeout: 15000 });

const router = new Router({
	// Hash URLs (/#/signup) so a refresh or deep link only ever asks the server for /.
	mode: 'hash',
	routes:[
		{ path:'/', name:'home', component:Home },
		{ path:'/faq', name:'faq', component:FAQ },
		{ path:'/guide', name:'guide', component:Articles },
		{ path:'/dl', name:'download', component:Download },
		{ path:'/signup', name:'signup', meta: { api: api }, component:Signup },
		// One route for every employer: the slug is the employer's shortName, looked up
		// against SignupParameters on mount. A slug the API does not know falls back to the
		// plain signup page rather than 404ing.
		{ path:'/signup/:employer', name:'signupemployer', meta: { api: api }, component:Signup },
		{ path:'/employers', name:'employers', component:Employers },
		{ path:'/features', name:'features', component:Features },
		{ path:'/about', name:'about', component:About },
		{ path:'/get-it-at-work', name:'getitatwork', component:GetItAtWork },
		{ path:'/policy', name:'policy', component:Policy },
		{ path:'/terms', name:'terms', component:Terms },
		{ path:'/appterms', name:'appterms', component:AppTerms },
		{ path:'/linked', name:'linked', component:Linked },
		{ path:'/welcome', name:'welcome', component:Welcome },
		{ path:'/launch', name:'launch', component:Launch },
		{ path:'/article/:slug', name:'article', component:Article },
		{ path:'/employeekeysupload', name:'employeekeysupload', component:EmployeeKeysUpload, meta: { api: api } },
		{ path:'/mail', name:'mail', component:Mail },
		// The original per-employer paths (/kentpolice and friends), kept alive for links
		// already in the wild on posters, QR codes and internal comms. Anything else that
		// looks like a slug lands on signup too, which falls back to the plain page when
		// SignupParameters doesn't know it. Query is preserved so any ?c= still arrives.
		// ponytail: one route instead of a list that has to be kept up to date. Cost is that
		// a typo'd top-level URL shows signup rather than 404; add a list back if that matters.
		{ path:'/:employer', redirect: (to) => ({ path: '/signup/' + to.params.employer, query: to.query }) },
		// Catch-all stays last: vue-router matches in order.
		{ path:'*', name:'notfound', component:NotFound }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return { selector: to.hash };
		}
		return { x: 0, y: 0 };
	}
});

router.afterEach(() => {
	// Move focus to the page content so keyboard / screen reader users
	// don't get stranded on the old page after a client-side navigation
	Vue.nextTick(() => {
		const main = document.getElementById('main');
		if (main) {
			main.focus({ preventScroll: true });
		}
	});
});

new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
